var _style, _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenOrkan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000098935333696517783670000012247817533888861112_);}\r\n\t.st1{fill:#131B24;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 100,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016065594177613817450000007519474470877284534_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "orkan-logo-round",
    style: {
      clipPath: "url(#SVGID_00000016065594177613817450000007519474470877284534_)"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_305",
    className: "st1",
    cx: 50,
    cy: 50,
    r: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    transform: "translate(-18.599 -57.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3211",
    x: 40,
    y: 78.8,
    className: "st2",
    width: 57.1,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3212",
    x: 40,
    y: 99.9,
    className: "st2",
    width: 57.1,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    x: 40,
    y: 120.9,
    className: "st2",
    width: 57.1,
    height: 15.1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenOrkan);
export default __webpack_public_path__ + "static/media/token_ORKAN.c10c9e77.svg";
export { ForwardRef as ReactComponent };